<div *ngIf="modo==='normal'">
  <div class="header-section">
    <div class="container-m">
      <div class="content">
        <div class="text-group">
          <h1 class="title">Historial de Compras</h1>
          <p class="subtitle">
            Revisa el detalle de tus pedidos realizados en nuestra plataforma online.
          </p>
        </div>
        <button class="btn-vanguard btn-reload" (click)="reload()">
          <i class="mdi mdi-magnify-plus btn-icon" style="font-size: 1.2rem; color: white;"></i>
          Actualizar
        </button>
      </div>
    </div>
  </div>
  <div class="histlist">
    <div *ngIf="cargando" class="container-carga">
      <spinner></spinner>
    </div>
    <div *ngIf="!hayPedidos" class="avisoContainer">
      <div class="avisoBackground">
        <div class="avisoTexto">
          No posee Pedidos en su Historial
        </div>
      </div>
    </div>
    <historial-generic-wiew *ngFor="let historia of historial" (onRepat)="recompra($event)"
      (onClick)="verDetalle($event)" [pedidoH]="historia"></historial-generic-wiew>
  </div>
  <div *ngIf="!cargando">
    <mmax-helpfootbar></mmax-helpfootbar>
    <foo-mariano-max></foo-mariano-max>
  </div>
</div>